module.exports = __webpack_public_path__ + "img/How are you.5f335c5d.png";